document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-read-more]").forEach((component) => {
    const maxWords = parseInt(component.dataset.words || 20, 10);
    const originalHTML = component.innerHTML.trim();

    const text = component.textContent.trim();
    const words = text.split(/\s+/);

    if (words.length <= maxWords) return;

    const truncatedText = `${words.slice(0, maxWords).join(" ")}...`;

    const inner = document.createElement("div");
    inner.className = "read-more__inner";

    const content = document.createElement("div");
    content.className = "read-more__content";

    const truncated = document.createElement("div");
    truncated.className = "read-more__truncated";
    truncated.textContent = truncatedText;

    const full = document.createElement("div");
    full.className = "read-more__full";
    full.innerHTML = originalHTML;

    content.appendChild(truncated);
    content.appendChild(full);
    inner.appendChild(content);

    component.innerHTML = "";
    component.appendChild(inner);

    const toggle = document.createElement("span");
    toggle.className = "read-more__toggle";
    toggle.textContent = `${Theme.translations.read_more}`;
    component.appendChild(toggle);

    // Initial height
    inner.style.height = `${truncated.offsetHeight}px`;

    toggle.addEventListener("click", () => {
      const expanded = component.classList.toggle("expanded");

      const targetHeight = expanded
        ? full.offsetHeight
        : truncated.offsetHeight;

      inner.style.height = `${targetHeight}px`;
      toggle.textContent = expanded
        ? `${Theme.translations.read_less}`
        : `${Theme.translations.read_more}`;
    });
  });
});
